import React from 'react';
import { useTranslation } from 'react-i18next';

export default function IncompleteState({ onGoToDataEntry }) {
  const { t } = useTranslation();
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', padding: '60px 24px', textAlign: 'center',
    }}>
      <div style={{ fontSize: 48, marginBottom: 16 }}>🏭</div>
      <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--t0)', marginBottom: 8 }}>
        {t('oracle.incomplete_title')}
      </div>
      <div style={{ fontSize: 13, color: 'var(--t2)', maxWidth: 380, lineHeight: 1.65, marginBottom: 24 }}>
        {t('oracle.incomplete_subtitle')}
      </div>
      <button
        className="btn"
        onClick={onGoToDataEntry}
        style={{ minWidth: 180, fontSize: 13 }}
      >
        {t('oracle.incomplete_cta')}
      </button>
    </div>
  );
}
